import { FirstName } from '@dreryk/person-name-common-api';

import { BindingCreator } from '@dreryk/react-common';
import { FirstNameInput } from '@dreryk/react-components';

const FIRST_NAME_FIELD_NAME = 'firstName';
const FIRST_NAME_MAX_LENGTH = 50;

export type FirstNameFormBeanPart = {
   [FIRST_NAME_FIELD_NAME]: FirstName | null;
};

type FirstNameFieldProps = {
   readonly register: BindingCreator<FirstNameFormBeanPart, typeof FIRST_NAME_FIELD_NAME>;
};

export const FirstNameField = (props: FirstNameFieldProps): JSX.Element => {
   return (
      <FirstNameInput
         controller={props.register(FIRST_NAME_FIELD_NAME, {
            required: true,
            /*
             * TODO: DREGAB-19275 - Poprawa walidacji tak by populowała walidacje z wnętrza komponentu
             * react-components i nie trzeba było ich powtarzać ponownie podczas rejestracji pola
             */
            maxLength: FIRST_NAME_MAX_LENGTH,
         })}
         testId={FIRST_NAME_FIELD_NAME}
      />
   );
};
